(function () {
  var modal = document.querySelector('[data-bcf-email-offer]');
  if (!modal) return;

  var params = new URLSearchParams(window.location.search);
  if (params.get('plinko') === 'off') return;

  var storageKey = 'bcf-second-rope-reveal-v3';
  var isThemePreview = Boolean(window.Shopify && (
    window.Shopify.designMode ||
    (window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main')
  ));
  var forced = params.get('plinko') === '1' && isThemePreview;
  var entry = modal.querySelector('[data-reveal-entry]');
  var formView = modal.querySelector('[data-reveal-form]');
  var result = modal.querySelector('[data-drop-result]');
  var form = document.getElementById('bcf-email-offer-form');
  var tab = document.querySelector('[data-drop-tab]');
  var reopen = document.querySelector('[data-drop-reopen]');
  var tabClose = document.querySelector('[data-drop-tab-close]');
  var state = '';
  try { state = window.localStorage.getItem(storageKey) || ''; } catch (error) {}
  if (!state) {
    try { state = window.sessionStorage.getItem(storageKey) || ''; } catch (error) {}
    if (state) {
      try { window.localStorage.setItem(storageKey, state); } catch (error) {}
    }
  }

  function remember(value) {
    state = value;
    try { window.localStorage.setItem(storageKey, value); } catch (error) {}
    try { window.sessionStorage.setItem(storageKey, value); } catch (error) {}
  }

  function capture(name, detail) {
    var properties = Object.assign({ sku: modal.dataset.bcfOfferSku || '', placement: 'pdp_entry' }, detail || {});
    window.dispatchEvent(new CustomEvent('bcf:' + name, { detail: properties }));
    if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture('bcf_' + name, properties);
  }

  function show(view) {
    entry.hidden = view !== 'entry';
    formView.hidden = view !== 'form';
    result.hidden = view !== 'result';
  }

  function showTab(visible) {
    if (tab) tab.hidden = !visible;
  }

  function open(view, trigger) {
    var openTrigger = trigger || 'tab_reopen';
    if (openTrigger === 'auto_open') remember('seen');
    show(view || 'entry');
    modal.hidden = false;
    document.documentElement.classList.add('bcf-drop-open');
    showTab(false);
    if (openTrigger === 'auto_open' || openTrigger === 'qa_forced') {
      capture('email_offer_viewed', { view: view || 'entry', trigger: openTrigger });
    } else {
      capture('email_offer_reopened', { view: view || 'entry', trigger: openTrigger });
    }
    window.setTimeout(function () {
      var focusTarget = modal.querySelector(view === 'form' ? '[data-drop-email]' : '[data-reveal-card]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }, 30);
  }

  function close(nextState) {
    modal.hidden = true;
    document.documentElement.classList.remove('bcf-drop-open');
    if (nextState) remember(nextState);
    showTab(state === 'dismissed');
  }

  var postedSuccessfully = formView.dataset.formSuccess === 'true';
  var hasErrors = formView.dataset.formErrors === 'true';
  if (postedSuccessfully) {
    remember('captured');
    close('captured');
    capture('email_offer_captured');
  } else if (hasErrors) {
    open('form', 'form_error');
  } else if (forced || !state) {
    window.setTimeout(function () { open('entry', forced ? 'qa_forced' : 'auto_open'); }, forced ? 100 : 900);
  } else if (state === 'dismissed' || state === 'seen') {
    showTab(true);
  }

  modal.querySelectorAll('[data-reveal-card]').forEach(function (card) {
    card.addEventListener('click', function () {
      modal.querySelectorAll('[data-reveal-card]').forEach(function (item) {
        item.disabled = true;
        if (item === card) item.classList.add('is-picked');
      });
      modal.querySelector('.bcf-reveal-hint').textContent = '30% off your second Rope';
      capture('email_offer_revealed', { card: card.dataset.revealCard || '' });
      window.setTimeout(function () {
        show('form');
        var email = formView.querySelector('[data-drop-email]');
        if (email) email.focus({ preventScroll: true });
      }, 520);
    });
  });

  var submitting = false;
  function submitOffer(event) {
      if (!form || submitting) {
        if (event) event.preventDefault();
        return;
      }
      var email = form.querySelector('[data-drop-email]');
      var error = form.querySelector('[data-drop-error]');
      if (!email || !email.validity.valid) {
        if (event) event.preventDefault();
        if (error) error.textContent = 'Enter a valid email address.';
        if (email) email.focus();
        return;
      }
      /* Shopify's customer form is protected by its native hCaptcha flow,
         so the reliable path is the normal form post. Mark the offer captured
         before navigation: after Shopify returns to the PDP, the popup stays
         closed and the shopper resumes where they left off. Server-side form
         errors still reopen the form through data-form-errors above. */
      submitting = true;
      try { window.localStorage.setItem('bcf-klaviyo-identify', email.value); } catch (error) {}
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { $email: email.value }]);
      remember('captured');
      capture('email_offer_submitted');
      close('captured');
      if (error) error.textContent = '';
  }

  if (form) {
    form.addEventListener('submit', submitOffer, true);
  }

  modal.querySelectorAll('[data-drop-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      capture('email_offer_dismissed');
      close('dismissed');
    });
  });
  var continueButton = modal.querySelector('[data-drop-continue]');
  if (continueButton) continueButton.addEventListener('click', function () { close('captured'); });
  if (reopen) reopen.addEventListener('click', function () { open('entry', 'tab_reopen'); });
  if (tabClose) tabClose.addEventListener('click', function () {
    remember('tab-hidden');
    showTab(false);
    capture('email_offer_tab_dismissed');
  });
  document.addEventListener('keydown', function (event) {
    if (!modal.hidden && event.key === 'Escape') close('dismissed');
  });
})();
